import React, {useEffect, useState} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "config/axiosConfig";
import {formatPrice} from "../../../../util/helpers";

function Edit(props) {
    const [title, setTitle] = useState('');

    const [content, setContent] = useState({visible: false, beforeRuralSpecialTaxAmount: 0});
    const [etcGuides, setEtcGuides] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search); // 쿼리 파라미터 추출
    const bizId = queryParams.get("bizId");
    const year = queryParams.get("year");
    const incomeTaxId = queryParams.get("incomeTaxId") || "";

    const requestGetBiz = () => {
        axios.get(`/admin/bizs/${bizId}`)
            .then((res) => {
                if(res.data !== null) {
                    setTitle(`${year}년 ${res.data.name} 예상종합소득세`);
                }
            });
    }

    const requestGetIncomeTax = () => {
        if (incomeTaxId === "") { return; }
        axios.get(`/admin/biz/expected-income-taxes/${incomeTaxId}`)
            .then((res) => {
                setContent(res.data);
                setEtcGuides(res.data.etcGuides);
            });
    }

    const requestSave = () => {
        const params = content;
        params.bizId = bizId;
        params.year = year;
        params.etcGuides = etcGuides;

        if (incomeTaxId !== "") {
            axios.put(`/admin/biz/expected-income-taxes/${incomeTaxId}`, JSON.stringify(params))
                .then((res) => {
                    alert('수정 되었습니다.');
                    navigate(-1);
                });
        } else {
            axios.post(`/admin/biz/expected-income-taxes`, JSON.stringify(params))
                .then((res) => {
                    alert('생성 되었습니다.');
                    navigate(-1);
                });
        }
    }

    /**
     * 세율
     * @param amount
     * @returns {number}
     */
    const getTaxRate = (amount) => {
        if (amount <= 14000000) { return 6 }
        if (amount <= 50000000) { return 15 }
        if (amount <= 88000000) { return 24 }
        if (amount <= 150000000) { return 35 }
        if (amount <= 300000000) { return 38 }
        if (amount <= 500000000) { return 40 }
        if (amount <= 1000000000) { return 42 }
        return 45
    }

    /**
     * 누진공제액
     * @param amount
     * @returns {number}
     */
    const getProgressiveDeductionAmount = (amount) => {
        if (amount <= 14000000) { return 0 }
        if (amount <= 50000000) { return 1260000 }
        if (amount <= 88000000) { return 5760000 }
        if (amount <= 150000000) { return 15440000 }
        if (amount <= 300000000) { return 19940000 }
        if (amount <= 500000000) { return 25940000 }
        if (amount <= 1000000000) { return 65940000 }
        return 65940000
    }

    const getCalculatedTaxAmount = (taxableIncomeAmount, taxRate) => {
        return ((taxableIncomeAmount ?? 0) * (taxRate ?? 0) / 100) - getProgressiveDeductionAmount(taxableIncomeAmount ?? 0);
    }

    const renderGuideField = (title, fieldKey, hint) => (
        <div className="card-body" style={{padding: '0', marginBottom: '10px'}}>
            <label className="col-sm-12 col-form-label" style={{marginLeft: '5px'}}>{title}</label>
            <div className="col-sm-12">
            <textarea
                className="form-control"
                rows={3}
                onChange={event => {
                    setContent({ ...content, [fieldKey]: event.target.value });
                }}
                value={content[fieldKey] ?? ""}
                placeholder={`일관성있는 서비스 제공을 위해 내용은 '해요체'로 작성해주세요.\n${hint}`}
            />
            </div>
        </div>
    );

    const renderAmountField = (fieldKey, isReadOnly = false) => (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <input type="text" className="form-control"
                   style={{width: "150px", textAlign: "right"}}
                   readOnly={isReadOnly}
                   onChange={event => {
                       let amount = event.target.value.replaceAll(",", "").replace(/[^0-9]/g, "");
                       setContent({ ...content, [fieldKey]: amount === "" ? null : Number(amount) });
                   }}
                   value={formatPrice(content[fieldKey]) ?? ""}
            />
        </div>
    );

    useEffect(() => {
        const taxable = Number(content.taxableIncomeAmount ?? 0);

        if (!content.taxableIncomeAmount || isNaN(taxable) || taxable === 0) {
            if (content.taxRate !== null) {
                setContent(prev => ({ ...prev, taxRate: null, calculatedTaxAmount: null }));
            }
            return;
        }

        const rate = getTaxRate(taxable);
        const calculatedTaxAmount = getCalculatedTaxAmount(content.taxableIncomeAmount ?? 0, rate ?? 0)
        setContent(prev => ({ ...prev, taxRate: rate, calculatedTaxAmount: Math.floor(calculatedTaxAmount) }));

    }, [content.taxableIncomeAmount])

    useEffect(() => {
        const taxable = Number(content.beforeTaxableIncomeAmount ?? 0);

        if (!content.beforeTaxableIncomeAmount || isNaN(taxable) || taxable === 0) {
            if (content.beforeTaxRate !== null) {
                setContent(prev => ({ ...prev, beforeTaxRate: null, beforeCalculatedTaxAmount: null }));
            }
            return;
        }

        const rate = getTaxRate(taxable);
        const calculatedTaxAmount = getCalculatedTaxAmount(content.beforeTaxableIncomeAmount ?? 0, rate ?? 0)
        setContent(prev => ({ ...prev, beforeTaxRate: rate, beforeCalculatedTaxAmount: Math.floor(calculatedTaxAmount) }));

    }, [content.beforeTaxableIncomeAmount])

    useEffect(() => {
        requestGetBiz();
        requestGetIncomeTax();
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>

                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">예상 종합소득세</li>
                                        <li className="breadcrumb-item active">생성 및 수정하기</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h3 style={{marginLeft: "20px"}}>{title}</h3>
                    <div style={{marginLeft: "20px"}}>

                    </div>

                    <div className="form-group row">
                        <div className="custom-control custom-switch custom-switch-on-success ml-auto" style={{marginRight: "20px"}}>
                            <input type="checkbox"
                                   className="custom-control-input"
                                   id="customSwitch3"
                                   checked={content.visible}
                                   onChange={ e => {
                                       setContent({...content, visible: e.target.checked});
                                   }}
                            />
                            <label className="custom-control-label" htmlFor="customSwitch3">
                                {
                                    content.visible
                                        ? <span>노출(ON)</span>
                                        : <span>노출(OFF)</span>
                                }
                            </label>
                        </div>
                    </div>

                    <section className="content" style={{marginTop: '20px'}}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="card card-navy col-sm-12" style={{marginBottom: "20px"}}>
                                    <div className="card-header">
                                        <h3 className="card-title" style={{marginTop: "10px"}}>예상 종합소득세 요약</h3>
                                        <div className="row justify-content-end" style={{ marginTop: '0px' }}>
                                            <div>
                                                <input
                                                    id = "addGuide"
                                                    type="text"
                                                    className="form-control"
                                                    style={{ width: "300px", textAlign: "right" }}
                                                    placeholder="추가 안내 제목 입력후 추가하기"
                                                />
                                            </div>
                                            <div style={{ marginLeft: "10px", marginTop: "3px" }}>
                                                <button
                                                    id = "addGuideBtn"
                                                    type="button"
                                                    className="btn-sm btn-default"
                                                    onClick={() => {
                                                        const addTitle = document.getElementById("addGuide").value;
                                                        if (addTitle.trim() === "") {
                                                            alert("추가할 제목을 입력하세요.");
                                                        } else {
                                                            setEtcGuides(prev => [...prev, { title: addTitle, guide: "" }]);
                                                            document.getElementById("addGuide").value = "";
                                                        }
                                                    }}>
                                                    추가
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                    {renderGuideField("매출 기준 안내", "revenueBasisGuide", "EX) 상반기(1월~6월) 매출을 기준으로 연간 예상 매출은 909,496원이에요.")}
                                    {renderGuideField("장부 유형 확인 안내", "bookkeepingTypeGuide", "EX) 대표님은 복식부기 의무자에 해당돼요.")}
                                    {renderGuideField("세액 감면 및 공제 적용 여부 안내", "taxReductionAppliedGuide", "EX) 대표님은 청년 창업 감면 100%대상이셔서, 약 36,377,694원의 세액이 감면될 수 있어요.")}
                                    {renderGuideField("인건비 신고 안내", "laborCostDeclarationGuide", "")}

                                    {
                                        etcGuides.map((item, index) => (
                                            <div key={index} className="card-body" style={{padding: '0', marginBottom: '10px'}}>
                                                <div className="row" style={{ marginTop: '0px' }}>
                                                    <label className="col-form-label" style={{marginLeft: '20px', marginRight: "10px"}}>{item.title}</label>
                                                    <button type="button" className="btn btn-sm" style={{color: 'red'}}
                                                            onClick={() => {
                                                                const newGuides = [...etcGuides];
                                                                newGuides.splice(index, 1);
                                                                setEtcGuides(newGuides);
                                                            }}>
                                                        삭제
                                                    </button>
                                                </div>
                                                <div className="col-sm-12">
                                                    <textarea
                                                        className="form-control"
                                                        rows={3}
                                                        onChange={event => {
                                                            const newGuides = [...etcGuides];
                                                            newGuides[index] = {...newGuides[index], guide: event.target.value};
                                                            setEtcGuides(newGuides);
                                                        }}
                                                        value={item.guide ?? ""}
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="content" style={{marginTop: '20px'}}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="card card-navy col-sm-12" style={{marginBottom: "20px"}}>
                                    <div className="card-header">
                                        <h3 className="card-title">자금흐름 요약</h3>
                                    </div>

                                    <div className="card-body" style={{padding: '0', marginBottom: '10px'}}>
                                        <div className="row">

                                            <div style={{marginLeft: "20px", marginRight: "12px", width: "300px"}}>
                                                <table className="table table-hover text-nowrap" style={{textAlign: "left"}}>
                                                    <tbody>
                                                    <tr>
                                                        <th>매출</th>
                                                        <td>{renderAmountField("saleAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>매출 원가</th>
                                                        <td>{renderAmountField("costSaleAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>매출 총이익</th>
                                                        <td style={{textAlign: 'right', fontWeight: 'bold'}}>{formatPrice((content.saleAmount ?? 0) - (content.costSaleAmount ?? 0))} 원</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div style={{marginRight: "12px", width: "300px"}}>
                                                <table className="table table-hover text-nowrap" style={{textAlign: "left"}}>
                                                    <tbody>
                                                    <tr>
                                                        <th>소모품비</th>
                                                        <td>{renderAmountField("suppliesAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>지급 수수료</th>
                                                        <td>{renderAmountField("commissionAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>기타 비용</th>
                                                        <td>{renderAmountField("otherExpenseAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>인건비</th>
                                                        <td>{renderAmountField("laborAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>감가상각비</th>
                                                        <td>{renderAmountField("depreciationAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>판매관리비</th>
                                                        <td style={{textAlign: 'right', fontWeight: 'bold'}}>
                                                            {formatPrice(
                                                                (content.suppliesAmount ?? 0) +
                                                                (content.commissionAmount ?? 0) +
                                                                (content.otherExpenseAmount ?? 0) +
                                                                (content.laborAmount ?? 0) +
                                                                (content.depreciationAmount ?? 0)
                                                            )} 원
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div style={{marginRight: "12px", width: "350px"}}>
                                                <table className="table table-hover text-nowrap" style={{textAlign: "left"}}>
                                                    <tbody>
                                                    <tr>
                                                        <th>신용카드발행세액공제 등</th>
                                                        <td>{renderAmountField("creditCardTaxCreditAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>영업 외 수익</th>
                                                        <td style={{textAlign: 'right', fontWeight: 'bold'}}>{formatPrice(content.creditCardTaxCreditAmount ?? 0)} 원</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div style={{marginRight: "12px", width: "300px"}}>
                                                <table className="table table-hover text-nowrap" style={{textAlign: "left"}}>
                                                    <tbody>
                                                    <tr>
                                                        <th>기부금 등</th>
                                                        <td>{renderAmountField("donationAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>영업 외 비용</th>
                                                        <td style={{textAlign: 'right', fontWeight: 'bold'}}>{formatPrice(content.donationAmount ?? 0)} 원</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {/* 세전이익 = 매출 총이익 - 판매관리비 + 영업외수익 - 영업외비용값 */}
                                        <h4 style={{marginLeft: "10px", marginTop: "10px", color: "blue"}}>세전이익: {formatPrice(
                                            ((content.saleAmount ?? 0) - (content.costSaleAmount ?? 0)) // 매출 총 이익
                                            - ((content.suppliesAmount ?? 0) + (content.commissionAmount ?? 0) + (content.otherExpenseAmount ?? 0) + (content.laborAmount ?? 0) + (content.depreciationAmount ?? 0)) // 판매관리비
                                            + (content.creditCardTaxCreditAmount ?? 0) // 영업외 수익
                                            - (content.donationAmount ?? 0) // 영업외 비용
                                        )} 원
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="content" style={{marginTop: '20px'}}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="card card-navy col-sm-12" style={{marginBottom: "20px"}}>
                                    <div className="card-header">
                                        <h3 className="card-title">컨설팅</h3>
                                    </div>

                                    <div className="card-body" style={{padding: '0', marginBottom: '10px'}}>
                                        <div className="row">

                                            <div style={{marginLeft: '20px', marginRight: "100px", width: "400px"}}>
                                                <div className="card-header">
                                                    <h3 className="card-title" style={{fontWeight: 'bold', color: 'grey'}}>컨설팅 전</h3>
                                                </div>
                                                <table className="table table-hover text-nowrap" style={{textAlign: "left"}}>
                                                    <tbody>
                                                    <tr>
                                                        <th>소득공제</th>
                                                        <td>{renderAmountField("beforeIncomeDeductionAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>과세표준</th>
                                                        <td>{renderAmountField("beforeTaxableIncomeAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>세율(%)</th>
                                                        <td>{renderAmountField("beforeTaxRate", true)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <div>산출세액</div>
                                                            <div style={{color: "gray", fontWeight: "normal", fontSize: "10pt"}}>과세표준 * 세율 - 누진공제</div>
                                                        </th>
                                                        <td>{renderAmountField("beforeCalculatedTaxAmount", true)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>세액감면</th>
                                                        <td>{renderAmountField("beforeTaxReductionAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>세액공제</th>
                                                        <td>{renderAmountField("beforeTaxCreditAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>농특세</th>
                                                        <td>{renderAmountField("beforeRuralSpecialTaxAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>종합소득세</th>
                                                        <td>{renderAmountField("beforeComprehensiveIncomeTaxAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>지방세</th>
                                                        <td>{renderAmountField("beforeLocalIncomeTaxAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>예상 종합소득세</th>
                                                        <td style={{textAlign: 'right', fontWeight: 'bold'}}>{formatPrice((content.beforeRuralSpecialTaxAmount ?? 0) + (content.beforeComprehensiveIncomeTaxAmount ?? 0) + (content.beforeLocalIncomeTaxAmount ?? 0))} 원</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div style={{marginRight: "12px", width: "400px"}}>
                                                <div className="card-header">
                                                    <h3 className="card-title" style={{fontWeight: 'bold', color: 'grey'}}>컨설팅 후</h3>
                                                </div>
                                                <table className="table table-hover text-nowrap" style={{textAlign: "left"}}>
                                                    <tbody>
                                                    <tr>
                                                        <th>소득공제</th>
                                                        <td>{renderAmountField("incomeDeductionAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>과세표준</th>
                                                        <td>{renderAmountField("taxableIncomeAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>세율(%)</th>
                                                        <td>{renderAmountField("taxRate", true)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <div>산출세액</div>
                                                            <div style={{color: "gray", fontWeight: "normal", fontSize: "10pt"}}>과세표준 * 세율 - 누진공제</div>
                                                        </th>
                                                        <td>{renderAmountField("calculatedTaxAmount", true)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>세액감면</th>
                                                        <td>{renderAmountField("taxReductionAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>세액공제</th>
                                                        <td>{renderAmountField("taxCreditAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>농특세</th>
                                                        <td>{renderAmountField("ruralSpecialTaxAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>종합소득세</th>
                                                        <td>{renderAmountField("comprehensiveIncomeTaxAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>지방세</th>
                                                        <td>{renderAmountField("localIncomeTaxAmount")}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>예상 종합소득세</th>
                                                        <td style={{textAlign: 'right', fontWeight: 'bold'}}>{formatPrice((content.ruralSpecialTaxAmount ?? 0) + (content.comprehensiveIncomeTaxAmount ?? 0) + (content.localIncomeTaxAmount ?? 0))} 원</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div className="row" style={{marginTop: "20px", marginBottom: "20px"}}>
                        <div style={{margin: "0 auto"}}>
                            <button type="button" className="btn btn-outline-secondary"
                                    onClick={() => navigate(-1)}>
                                목록
                            </button>
                            <button type="button" className="btn btn-outline-primary"
                                    style={{marginLeft: "10px"}}
                                    onClick={requestSave}>
                                {!incomeTaxId ? '저장' : '수정'}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Edit;
